<template>
  <div class="catalog-actions">
    <or-icon-button
      ref="actionsButton"
      icon="more_vert"
      size="small"
      type="secondary"
      class="actions"
      has-dropdown
      disableRipple
      @click="handleButtonClick"
    >
      <or-menu
        class=""
        slot="dropdown"
        contain-focus
        has-icons
        disable-ripple
        :options="actionsOptions"
        @select="handleAction"
        @close="$refs.actionsButton.closeDropdown()"
      />
    </or-icon-button>
    <or-modal
      ref="delete-model-confirm"
      type="danger"
      confirm-button-text="Delete"
      :title="$t('home.catalog_actions.delete_modal.title')"
      removeCloseButton
    >
      <div class="delete-model-body">
        <i18n path="home.catalog_actions.delete_modal.description" tag="div">
          <template v-slot:knowledgeModelName>
            <b>{{ knowledgeModel.name }}</b>
          </template>
        </i18n>
        <div class="delete-model-actions">
          <or-button
            color="red"
            @click="handleDelete"
            class="delete-btn"
            :loading="isDeleting"
          >
            {{$t('generic.delete')}}
          </or-button>
          <or-button
            type="secondary"
            color="primary"
            @click="handleCancelDeletion"
            :disabled="isDeleting"
          >
            {{$t('generic.keepIt')}}
          </or-button>
        </div>
      </div>
    </or-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { downloadFile } from '@/utils/utils'

export default {
  name: 'catalog_actions',

  data () {
    return {
      isDeleting: false,
      isExporting: false
    }
  },

  props: {
    knowledgeModel: Object,
    isCustom: Boolean
  },

  computed: {
    actionsOptions () {
      const options = []
      if (!this.$props.isCustom) {
        options.push({
          label: this.$t('home.catalog_actions.actions.export'),
          icon: 'publish',
          action: 'export',
          disabled: this.isExporting
        })
      }
      options.push({
        label: this.$t('home.catalog_actions.actions.delete'),
        icon: 'delete',
        action: 'delete',
        disabled: this.isDeleting
      })
      return options
    }
  },

  methods: {
    ...mapActions('knowledgebase', [
      'exportKnowledgeBase',
      'deleteKnowledgeModel'
    ]),
    ...mapActions('knowledgebase/customModels', ['deleteCustomModel']),

    handleCancelDeletion (e) {
      e.stopPropagation()
      e.preventDefault()
      this.$refs['delete-model-confirm'].close()
      this.$refs.actionsButton.closeDropdown()
    },

    async handleDelete (e) {
      e.stopPropagation()
      e.preventDefault()
      this.isDeleting = true
      if (this.$props.isCustom) {
        await this.deleteCustomModel(this.knowledgeModel.id)
      } else {
        await this.deleteKnowledgeModel({ id: this.knowledgeModel.id })
      }
      this.isDeleting = false
    },

    async exportModel () {
      this.isExporting = true
      try {
        const data = await this.exportKnowledgeBase({ id: this.knowledgeModel.id })
        downloadFile(data)
      } catch (error) {
        this.addError({
          title: this.$t('home.catalog_actions.errors.export.title'),
          error: error.message
        })
      }
      this.isExporting = false
    },

    handleAction (action) {
      switch (action.action) {
        case 'export': {
          this.exportModel()
          break
        }
        case 'delete': {
          this.$refs['delete-model-confirm'].open()
          break
        }
        default: break
      }
    },

    handleButtonClick (e) {
      e.stopPropagation()
      e.preventDefault()
    }
  }
}
</script>

<style scoped lang="scss">
  .catalog-actions {
    margin-top: -8px;
  }
  .actions {
    z-index: 1;
  }
  .delete-model-body {
    .delete-model-actions {
      display: flex;
      justify-content: flex-end;
      margin: 16px 0;
      .delete-btn {
        margin-right: 16px;
      }
    }
  }
</style>
